import { Module } from "@nestjs/common";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { TypeOrmModule } from '@nestjs/typeorm';
import { PurchasesEntity } from "./purchases.entity";
import { PurchasesController } from "./purchases.controller";
import { PurchaseProductsEntity } from "./purchases-product.entity";
import { PurchasesService } from "./purchases.service";
import { UnitcodeService } from "libs/shared-services/masters/src/lib/unit-code.services";


@Module({
    imports: [
      TypeOrmModule.forFeature([PurchasesEntity,PurchaseProductsEntity])
    ],
    controllers: [PurchasesController],
    providers: [ApplicationExceptionHandler,PurchasesController,PurchasesService,UnitcodeService],
  })
  export class PurchasesModule { }